// extracted by css-extract-rspack-plugin
export default {"menuItem":"menu-item--DzLukLw8TAE6RskL","menuItemActive":"menu-item-active--DXdxCwZ7pXwiO5Fi"};